import { RichText } from "~/components/ui/store/RichText"
import clsx from "~/sdk/clx"

export interface RichTextSectionProps {
    /**
     * @title Texto
     * @format html
     * @description Cadastre o texto, você pode definir pelo editor se é um título H1 da página, atente-se de usar apenas um título H1 por página.
     */
    text: string
}

const RichTextSection = ({ text }: RichTextSectionProps) => {
    if (!text) return null

    return (
        <div className={clsx('px-2 w-full max-w-[1810px] mx-auto')}>
            <RichText text={text} />
        </div>
    )
}

export default RichTextSection
export { default as LoadingFallback } from "~/components/LoadingFallback"
